import styled from "styled-components";
import {
  buttonBorder,
  buttonShadow,
  lightestColor,
  primaryColor,
  secondaryColor,
} from "../../styles";

export const StyledButton = styled("button")<any>`
  background: ${(p) => p.color || primaryColor};
  color: ${(p) => (p.color ? primaryColor : lightestColor)};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 1px solid ${buttonBorder};
  border-radius: 4px;
  padding: 13px 0;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 180px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px ${buttonShadow};

  &:hover,
  &:active,
  &:focus {
    color: ${lightestColor};
    border: 1px solid ${secondaryColor};
    background-color: ${secondaryColor};
  }
`;
